const factoryNetCentsDomains = ['net-cents', 'localhost'];

export const factoryNetCentsUser = () =>
  factoryNetCentsDomains.some(url => window.location.href.includes(url));
